// if ($('.sidebar').length > 0) {
//     var sidebarOffset = $('.header__container #header').outerHeight() - 2,
//         sidebarTop = $('.sidebar').offset().top;

//         console.log(sidebarOffset);
// }



// function wu_clone_sidebar() {
//     if ($('.sidebar').length > 0) {
//         var sidebarContent = $('.sidebar').html();
//         $('body').append('<div class="sidebar--fixed bg-lightwhite hidden">' + sidebarContent + '</div>');
//         $('.sidebar--fixed').width($('.sidebar').width()).css('top', sidebarOffset + 'px');
//     }
// }
// wu_clone_sidebar();


// function wu_fix_sidebar() {
//     var windowScroll = $(window).scrollTop(),
//         sidebarScrollPosition = sidebarTop - windowScroll;
//     if (sidebarScrollPosition <= sidebarOffset) {
//         $('.sidebar').addClass('hidden');
//         $('.sidebar--fixed').removeClass('hidden');
//         $('.sidebar--fixed').addClass('school__bg');
//     } else {
//         $('.sidebar').removeClass('hidden');
//         $('.sidebar--fixed').addClass('hidden');
//         $('.sidebar--fixed').removeClass('school__bg');
//     }
// }

// $(window).scroll(function(event) {
//     wu_fix_sidebar();
// });

// function wu_resize_position_sidebar() {
//     var positionRight = ($(window).width() - $('.wrap > .content').width()) / 2;
//     $('.sidebar--fixed').css('right', positionRight + 'px');
// }
// wu_resize_position_sidebar();

// $(window).resize(function(event) {
//     wu_resize_position_sidebar();
// });

$(document).on('click', '.program__navlinks--internal a, .page__navlinks--internal a', function(event) {
  event.preventDefault();
  var id = $(this).attr('href'),
    top = $(id).offset().top;
  $('body, html').animate({
    scrollTop: top - 170
  });

});

/**
 *
 * Pull up the sidebar to the header image to setup for sticky.
 *
 */
function wu_get_header_offset() {
  var headerOffset = Math.abs(parseInt($('.program__header').css('margin-top')));
  // console.log(headerOffset);
  return headerOffset;
}

function wu_position_sidebar() {

  if($('.sidebar').length > 0 && $('.program__image').length > 0) {
    var programImageOffset = $('.program__image').offset().top + $('.program__image').outerHeight(),
      sidebarOffset = $('.sidebar').offset().top,
      difference = sidebarOffset - programImageOffset - parseInt($(".program__header").css('top')),
      sidebarMove = difference + wu_get_header_offset();


    $('.sidebar:not(.sidebar--landing)').css('margin-top', '-' + sidebarMove + 'px').attr('data-top', '-' + sidebarMove + 'px');

  }

}
wu_position_sidebar();

$(".sticky").stick_in_parent({
    recalc_every: 1,
    offset_top: 91,
    parent: '[data-sticky_parent]'
  }).on('sticky_kit:bottom', function(e) {
    $(this).parent().css('position', 'static');
  })
  .on('sticky_kit:unbottom', function(e) {
    $(this).parent().css('position', 'relative');
  });


// if ($('.sidebar').length > 0) {
//     sidebarWidth = $('.sidebar').innerWidth() - (parseInt($('.sidebar').css('padding-left')) * 2);

//     function wu_placeSidebar() {
//             //left = (wrapWidth * (10 / 12)) + marginWidth,

//             //sidebarWidth = (wrapWidth * (2 / 12)) - (parseInt($('.sidebar').css('padding-left')) * 2),



//         var wrapWidth = $('.wrap > .content:first').innerWidth(),
//             marginWidth = ($(window).width() - wrapWidth) / 2,
//             left = (wrapWidth - $('.sidebar').innerWidth()) + marginWidth,
//             top = $('.header__container').height();

//             $('.sidebar').css('left', left + 'px').css('top', top + 'px').css('visibility', 'visible').width(sidebarWidth);

//             var landingHeader = $('.program__header').position();

//             //console.log(wrapWidth);
//             //console.log(marginWidth);

//             $('.sidebar--landing').css('top', (landingHeader.top - top - (parseInt($('.sidebar').css('padding-left')) * 2) )+'px').css('width', $('.sidebar').innerWidth());

//     }

//     jQuery(document).ready(function($) {

//         wu_position_sidebar();

//         $('.sidebar:not(.sidebar--landing)').affix({
//             offset: {
//                 top: $('.sidebar').offset().top - $('.header__container').height(),
//                 bottom: function() {
//                     var wrapWidth = $('.wrap > .content:first').innerWidth(),
//                         marginWidth = ($(window).width() - wrapWidth) / 2,
//                         left = (wrapWidth - $('.sidebar').innerWidth()) + marginWidth;

//                     $('.sidebar').css('left', left + 'px');
//                     //console.log($('.modules > .row > .content__module:last').offset().top + $('.modules > .row > .content__module:last').height());
//                     return $('#footer').height() + 160;
//                 }
//             }
//         }).on('affixed.bs.affix', function(event) {
//             wu_placeSidebar();
//         });
//     });

//     $(window).load(function() {
//         wu_placeSidebar();
//         $('.content').css('position', 'relative');
//     });

//     $(window).resize(function(event) {
//       //  wu_position_sidebar();
//         wu_placeSidebar();
//     });




// }





function wu_mobile_sidebar() {

  if ($('.sidebar nav li').length > 0) {

    $('<div class="sidebar__mobile visible-sm visible-xs col-xs-12"><select name="sidebar__mobile__select" id="sidebar__mobile__select" class="sidebar__mobile__select form-control"></select></div>').insertBefore('.modules');
    $('.sidebar__mobile').affix({
      offset: {
        top: $('.sidebar__mobile').offset().top - $('.header__container').height()
      }
    });
  }

  $('.sidebar__nav > li').each(function(index, el) {
    var navSection = $(this).find('h4:first').text().trim();
    $('.sidebar__mobile__select').append('<optgroup label="' + navSection + '"></optgroup>');
    var newOptGroup = $('.sidebar__mobile__select optgroup[label="' + navSection + '"]');

    $(this).find('.sidebar__nav__pages > li').each(function(index, el) {
      //console.log('stuff');
      var value = $(this).find('a:first').attr('href'),
        label = $(this).find('a:first').text();
      if (window.location.pathname == value) {
        newOptGroup.append('<option value="' + value + '" selected>' + label + '</option>');
      } else {
        newOptGroup.append('<option value="' + value + '">' + label + '</option>');
      }
    });


  });
  if ($('.sidebar__nav__links').length > 0) {
    $('.sidebar__mobile__select').append('<option value="" disabled></option>');
    $('.sidebar__nav__links').find('a').each(function(index, el) {
      var value = $(this).attr('href'),
        label = $(this).text();
      $('.sidebar__mobile__select').append('<option value="' + value + '">' + label + '</option>');
    });
  }

  if ($('.program__navlinks').length > 0) {
    $('.program__navlinks').find('a').each(function(index, el) {
      var value = $(this).attr('href'),
        label = $(this).text();
      if (window.location.pathname == value) {
        $('.sidebar__mobile__select').append('<option value="' + value + '" selected>' + label + '</option>');
      } else {
        $('.sidebar__mobile__select').append('<option value="' + value + '">' + label + '</option>');
      }

    });
  }

  if ($('.program__navlinks--arch').length > 0) {
    $('.sidebar__mobile__select').append('<option value="" disabled></option>');
    var navSection = "Programs";
    $('.sidebar__mobile__select').append('<optgroup label="' + navSection + '"></optgroup>');
    var newOptGroup = $('.sidebar__mobile__select optgroup[label="' + navSection + '"]');
    $('.sidebar__mobile__select').append('<option value="" disabled></option>');
    $('.program__navlinks--arch').find('a').each(function(index, el) {
      var value = $(this).attr('href'),
        label = $(this).text();
      if (window.location.pathname == value) {
        newOptGroup.append('<option value="' + value + '" selected>' + label + '</option>');
      } else {
        newOptGroup.append('<option value="' + value + '">' + label + '</option>');
      }
    });
  }

  $(document).on('change', '.sidebar__mobile__select', function(event) {
    event.preventDefault();
    location.href = $(this).val();
  });
}
var sidebar = $('.sidebar:not(.sidebar--news)');

if (sidebar.length > 0) {
  wu_mobile_sidebar();
}
